import { render, staticRenderFns } from "./prop_cat.vue?vue&type=template&id=672cd7f7"
import script from "./prop_cat.vue?vue&type=script&lang=ts"
export * from "./prop_cat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports